const tiposPessoa= [
    { id: 'F', nome: 'Física' },
    { id: 'J', nome: 'Jurídica' }
  ]
  
  export default tiposPessoa


// WEBPACK FOOTER //
// ./src/vuex/cache/tiposPessoa.js